// IBHS-ABA supervision forms (supervision_sessions):
//   - entry form ([data-supervision-form]): live duration from the start and stop times, the form title and
//     BC-ABA-only fields for the chosen form type, and the BHT Supervision Discussion section while
//     "Supervised BHTs?" is checked
//   - sign page ([data-signature-form]): a signature pad whose drawing is posted as a PNG data URL
// Events are bound once on document so they keep working across Turbolinks page visits.
import SignaturePad from 'signature_pad/dist/signature_pad';

function minutesOf(value) {
  const match = /^(\d{1,2}):(\d{2})/.exec(value || '');
  return match ? Number(match[1]) * 60 + Number(match[2]) : null;
}

function updateDuration(form) {
  const output = form.querySelector('[data-sf-duration]');
  if (!output) return;

  const start = minutesOf(form.querySelector('[data-sf-start]')?.value);
  const end = minutesOf(form.querySelector('[data-sf-end]')?.value);
  if (start === null || end === null || end <= start) {
    output.textContent = '0';
    return;
  }
  const minutes = end - start;
  const hours = Math.floor(minutes / 60);
  output.textContent = `${hours ? `${hours} h ` : ''}${minutes % 60 ? `${minutes % 60} min` : ''}`.trim();
}

function updateFormType(form) {
  const select = form.querySelector('[data-sf-form-type]');
  if (!select) return;

  const type = select.value;
  const title = select.selectedOptions[0]?.dataset.title;
  form.querySelectorAll('[data-sf-title]').forEach((el) => { if (title) el.textContent = title; });
  const caseHeading = select.selectedOptions[0]?.dataset.caseHeading;
  form.querySelectorAll('[data-sf-case-heading]').forEach((el) => { if (caseHeading) el.textContent = caseHeading; });
  form.querySelectorAll('[data-sf-only]').forEach((el) => { el.hidden = el.dataset.sfOnly !== type; });

  const bhtToggle = form.querySelector('[data-sf-bht-toggle]');
  const showBht = type === 'bc_aba' && bhtToggle && bhtToggle.checked;
  form.querySelectorAll('[data-sf-bht-section]').forEach((el) => { el.hidden = !showBht; });
}

function refresh(form) {
  updateDuration(form);
  updateFormType(form);
}

['input', 'change'].forEach((type) => {
  document.addEventListener(type, (event) => {
    const form = event.target.closest('[data-supervision-form]');
    if (form) refresh(form);
  });
});

function initSignaturePad(form) {
  const canvas = form.querySelector('[data-signature-pad] canvas');
  const input = form.querySelector('[data-signature-input]');
  if (!canvas || !input || canvas.dataset.ready) return;

  canvas.dataset.ready = 'true';
  const ratio = Math.max(window.devicePixelRatio || 1, 1);
  canvas.width = canvas.offsetWidth * ratio;
  canvas.height = canvas.offsetHeight * ratio;
  canvas.getContext('2d').scale(ratio, ratio);
  const pad = new SignaturePad(canvas, { backgroundColor: 'rgb(255,255,255)', penColor: 'rgb(0,0,0)' });

  form.querySelector('[data-signature-clear]')?.addEventListener('click', () => pad.clear());
  form.addEventListener('submit', (event) => {
    if (pad.isEmpty()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      alert('Please sign in the box before saving.');
      return;
    }
    input.value = pad.toDataURL('image/png');
  });
}

document.addEventListener('turbolinks:load', () => {
  document.querySelectorAll('[data-supervision-form]').forEach(refresh);
  document.querySelectorAll('[data-signature-form]').forEach(initSignaturePad);
});
